import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, List, ListItem, ListItemText, Divider, Alert } from '@mui/material';
import { fetchJson } from '../../utils/fetchJson';

export default function ParentMessagesPage() {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchJson('/api/portal/parent/messages')
      .then((data) => { if (alive) setMessages(Array.isArray(data?.messages) ? data.messages : []); })
      .catch((e) => { if (alive) setError(e?.message || t('parentMessagesPage.errors.loadMessages')); });
    return () => { alive = false; };
  }, [t]);

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography variant="h5" gutterBottom>{t('parentMessagesPage.title')}</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <List>
        {messages.map((m) => (
          <React.Fragment key={m.id}>
            <ListItem>
              <ListItemText primary={m.content || t('parentMessagesPage.messageFallback')} secondary={m.createdAt ? new Date(m.createdAt).toLocaleString() : ''} />
            </ListItem>
            <Divider component="li" />
          </React.Fragment>
        ))}
        {messages.length === 0 && !error && (
          <ListItem><ListItemText primary={t('parentMessagesPage.empty')} /></ListItem>
        )}
      </List>
    </Box>
  );
}
